import Vue from 'vue'; // vue plugins
// ------------------------------

import vueCustomElement from 'vue-custom-element';
import 'document-register-element/build/document-register-element'; // IE対策

Vue.use(vueCustomElement);
import smoothScroll from 'vue-smoothscroll';
Vue.use(smoothScroll);
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload); // Vue Components
// ------------------------------

import TitleGroup from './title/title-group';
Vue.customElement('title-group', TitleGroup);
import TitleBlock from './title/title-block';
Vue.customElement('title-block', TitleBlock);
import DatePicker from './form/form-datepicker';
Vue.customElement('form-datepicker', DatePicker);
import ImageHeror from './image/image-hero';
Vue.customElement('image-hero', ImageHeror); // layouts

import AppHeader from './layout/header';
Vue.customElement('app-header', AppHeader);
import AppFooter from './layout/footer';
Vue.customElement('app-footer', AppFooter);
import DrawerMenu from './layout/drawer-menu';
Vue.customElement('drawer-menu', DrawerMenu); // component内でcomponentを利用しているケースがある
// その場合は先に使用しているcomponentを読み込ませておかないと
// エラーの原因となる

import EntryBox from './mt/entry-box';
Vue.customElement('entry-box', EntryBox);
import EntryList from './mt/entry-list';
Vue.customElement('entry-list', EntryList);
import EntryTable from './mt/entry-table';
Vue.customElement('entry-table', EntryTable);
import PageDetail from './mt/page-detail';
Vue.customElement('page-detail', PageDetail);
import EntryDetail from './mt/entry-detail';
Vue.customElement('entry-detail', EntryDetail);